import { render } from "./CobaltHeader.vue?vue&type=template&id=622bce18"
import script from "./CobaltHeader.vue?vue&type=script&lang=js"
export * from "./CobaltHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__